import en from './en'
import es from './es'
import jp from './jp'
import cn from './cn'

export default {
  en: en,
  es: es,
  jp: jp,
  cn: cn
}



// WEBPACK FOOTER //
// ./src/lang/index.js